import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=65d35299"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports